import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "_rounded--common _bxsh--base _flexcol _bgc--white" }
const _hoisted_2 = { class: "_pos-r _bgc--white gfu-background-swept _gap-2 _flex _ai-c _grow-1" }
const _hoisted_3 = { class: "_flexaicntr _gap-1" }
const _hoisted_4 = { class: "_flex _gap-1 _grow-1 _jc-sb" }
const _hoisted_5 = { class: "_flexcol _flex-basis-40 _gap-1" }
const _hoisted_6 = { class: "_flexcol _flex-basis-40 _gap-2 _jc-c" }

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_skeleton_line = _resolveComponent("skeleton-line")
  const _component_skeleton_image = _resolveComponent("skeleton-image")

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_skeleton_line, {
      height: 20,
      class: "_mb-3"
    }),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.itemsArray, (item) => {
        return (_openBlock(), _createElementBlock("div", {
          key: item,
          class: "_flexaicntr _gap-2 _px-2 _py-2 _bdb--default _bc--disabled _pos-r gfu-ranking-list"
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_skeleton_image, { size: 54 }),
              _createVNode(_component_skeleton_image, { size: 64 })
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_skeleton_line, { height: 22 }),
                _createVNode(_component_skeleton_line, { height: 16 })
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_component_skeleton_line, { height: 16 }),
                _createVNode(_component_skeleton_line, { height: 22 })
              ])
            ])
          ])
        ]))
      }), 128 /* KEYED_FRAGMENT */))
    ])
  ]))
}